// components/nft/empty-state.tsx
import { Plus } from 'lucide-react';
import React from 'react';

import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';

interface EmptyStateProps {
  onCreate: () => void;
}

export const EmptyState: React.FC<EmptyStateProps> = ({ onCreate }) => {
  return (
    <Card>
      <CardContent className="p-12 text-center">
        <div className="text-muted-foreground">
          <p className="text-lg mb-2">No NFTs found</p>
          <p className="mb-4">Try adjusting your search or create a new NFT</p>
          <Button onClick={onCreate}>
            <Plus className="w-4 h-4 mr-2" />
            Create Your First NFT
          </Button>
        </div>
      </CardContent>
    </Card>
  );
};
